import React, { useState, useContext, useMemo, useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams  } from "react-router-dom";
import { useAliveController } from 'react-activation'
import { Dropdown, message, ConfigProvider, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import MainContext from '@/stores/stores'
import { useIntl } from 'react-intl'
import styles from './index.module.scss'
import LogoImg from './LogoImg'
import accountApi from '@/api/accountApi';
import VinInput from "@/components/VinInput"
import { getDecryptParams } from '@/utils/utils'
import ExportinOe from "@/components/ExportinOe";
import { enToCn } from '@/utils/china-geo-map';

const HeaderFive: React.FC<any> = (props) => {
  const token = localStorage.getItem("token") || ''
  const { headerInfo = {} } = props
  const config = headerInfo.config ? headerInfo.config : {}
  const { pathname, search } = useLocation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const stock_merchant_id = searchParams.get('stock_merchant_id') || ''
  if(stock_merchant_id) {
    sessionStorage.setItem("stock-merchant-id", stock_merchant_id)
  }
  let params = searchParams.get("params")
  const intl = useIntl()
  const { refreshScope, clear, dropScope, drop, refresh  } = useAliveController()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { userInfo, isWomala, host, colorPrimary, fontColorPrimary, canLang, isCst, distributorInfo, hasFreeVin  } = commonStore

  let domain = window.location.host

  const [longer, setLonger] = useState<boolean>(true)
  const [allNav, setAllNav] = useState<any[]>([])
  const [standardNav, setStandardNav] = useState<any[]>([])
  const [moreNav, setMoreNav] = useState<any[]>([])

  const [isMobile, setIsMobile] = useState<boolean>(false)

  const [centerItems, setCenterItems] = useState<any[]>([])
  const [vinInputKey, setVinInputKey] = useState<string>('')

  const [merchantList, setMerchantList] = useState<any[]>([])
  const [merchantItem, setMerchantItem] = useState<any>({})

  const istest: number = window.location.host.includes("webtest") || window.location.host.includes("localhost:300") ? 1 : 0

  useEffect(() => {
    getNavgation()
    isModernPhone().then((isTrue: boolean) => {
      setIsMobile(isTrue)
    })
  }, [])

  useEffect(() => {
    if(commonStore.query_mode) {
      getMerchantList()
    }else {
      setMerchantItem({})
      setCommonStore({
        type: 'currentMerchant',
        value: {}
      })
      sessionStorage.setItem('stock-merchant-id', '')
    }
  }, [commonStore.query_mode])

  useEffect(() => {
    const lang: any  = window.localStorage.getItem('lang')
    if(lang === 'zh' || lang === 'cht') {
        if(document.body.clientWidth <= 1420) {
          setLonger(false)
        }else if(document.body.clientWidth <= 1800) {
          if((standardNav.length + moreNav.length) <= 8) {
            setLonger(true)
          }else {
            setLonger(false)
          }
        }else {
          setLonger(true)
        }
      }else {
        if(document.body.clientWidth <= 1800) {
          setLonger(false)
        }else if(document.body.clientWidth <= 2400) {
          if((standardNav.length + moreNav.length) <= 10) {
            setLonger(true)
          }else {
            setLonger(false)
          }
        }else {
          setLonger(true)
        }
      }
      if((standardNav.length + moreNav.length) <= 6) {
        setLonger(true)
      }
    
  },[standardNav, moreNav])

  useEffect(() => {
    let companyItems = commonStore.userInfo && commonStore.userInfo.is_repair_shop_admin ? [
      {
        key: '/mine/company',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/company')}>
            <i className="iconfont icon-a-Vector1 mr5"></i>
            {intl.formatMessage({ id: '公司管理' })}
          </div>
        )
      },
    ] : []
    const _items: any = commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 ? [
      {
        key: '/mine/aftersales',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/aftersales')}>
            <i className="iconfont icon-tuikuanshouhou mr5"></i>
            {intl.formatMessage({id: '退款/售后'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      {
        key: '/mine/reconciliation',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/reconciliation')}>
            <i className="iconfont icon-duizhangdan mr5"></i>
            {intl.formatMessage({id: '对账单'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      {
        key: '/mine/copewith',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/copewith')}>
            <i className="iconfont icon-yingfudan mr5"></i>
            {intl.formatMessage({id: '应付单'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      {
        key: '/mine/address',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/address')}>
            <i className="iconfont icon-dizhiguanli mr5"></i>
            {intl.formatMessage({id: '地址管理'})}
          </div>
        )
      },
      {
        key: '/mine/invoice',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/invoice')}>
            <i className="iconfont icon-fapiaotaitou mr5"></i>
            {intl.formatMessage({id: '发票抬头'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      ...companyItems,
      {
        key: '/mine/setting',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/setting')}>
            <i className="iconfont icon-shezhi mr5"></i>
            {intl.formatMessage({id: '设置'})}
          </div>
        )
      },
      {
        key: 'logout',
        label: (
          <div className="flex-s-c" onClick={logout}>
            <i className="iconfont icon-tuichudenglu1 mr5"></i>
            {intl.formatMessage({id: '退出登录'})}
          </div>
        )
      }
    ] : [
      {
        key: '/mine/address',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/address')}>
            <i className="iconfont icon-dizhiguanli mr5"></i>
            {intl.formatMessage({id: '地址管理'})}
          </div>
        )
      },
      {
        key: '/mine/invoice',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/invoice')}>
            <i className="iconfont icon-fapiaotaitou mr5"></i>
            {intl.formatMessage({id: '发票抬头'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      ...companyItems,
      {
        key: '/mine/setting',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/setting')}>
            <i className="iconfont icon-shezhi mr5"></i>
            {intl.formatMessage({id: '设置'})}
          </div>
        )
      },
      {
        key: 'logout',
        label: (
          <div className="flex-s-c" onClick={logout}>
            <i className="iconfont icon-tuichudenglu1 mr5"></i>
            {intl.formatMessage({id: '退出登录'})}
          </div>
        )
      }
    ]
    _items.unshift({
      key: '/mine/order',
      label: (
        <div className="flex-s-c" onClick={() => toCenterUrl('/mine/order')}>
          <i className="iconfont icon-wodedingdan mr5" />
          {intl.formatMessage({id: '我的订单'})}
        </div>
      )
    })
    setCenterItems(_items)
  }, [commonStore.userInfo, commonStore.distributorInfo])

  useEffect(() => {
    if(params) {
      let paramsObj = getDecryptParams(params)
      if(paramsObj.vin) {
        setVinInputKey(paramsObj.vin)
      }else if(paramsObj.brand && !paramsObj.vin) {
        setVinInputKey(paramsObj.brand)
      }else if(paramsObj.en_plate) {
        setVinInputKey(paramsObj.en_plate)
      }else if(paramsObj.oeList) {
        setVinInputKey(paramsObj.oeList)
      }else {
        setVinInputKey('')
      }
    }else {
      setVinInputKey('')
    }  
  }, [pathname, params])

  const getCityByIp = async () => {
    try {
      const res = await fetch('https://hackmyip.com/api/ip');
      const data = await res.json();
      let location = data.data && data.data.location ? data.data.location : {}
      console.log("getCityByIp location:", location)
      let latitude = location.latitude
      let longitude = location.longitude
      let city = location.city
      return city;
    } catch (e) {
      console.error('定位失败', e);
      return null;
    }
  }
  const getMerchantList = async () => {
    try {
      let city = await getCityByIp()
      let res = await accountApi.getMerchantList()
      if(res.code === 1) {
        let _data = res.data ? res.data : []
        setMerchantList(_data)
        let _stock_merchant_id = stock_merchant_id || sessionStorage.getItem('stock-merchant-id') || ''
        if(!_stock_merchant_id) {
          if(_data.length) {
            let cityCN = enToCn(city)
            console.log("cityCN:", cityCN)
            let index = _data.findIndex((ele: any) => ele.province_city.includes(cityCN))
            let _item = index === -1 ? _data[0] : _data[index]
            setMerchantItem(_item)
            setCommonStore({
              type: 'currentMerchant',
              value: _item
            })
            sessionStorage.setItem('stock-merchant-id', _item.merchant_id)
          }else {
            sessionStorage.setItem('stock-merchant-id', '')
            setCommonStore({
              type: 'currentMerchant',
              value: {}
            })
            setMerchantItem({})
          }
        }else {
          if(_data.length) {
            let index = _data.findIndex((ele: any) => ele.merchant_id === _stock_merchant_id)
            let _item = index === -1 ? _data[0] : _data[index]
            setMerchantItem(_item)
            setCommonStore({
              type: 'currentMerchant',
              value: _item
            })
            sessionStorage.setItem('stock-merchant-id', _item.merchant_id)
          }else {
            sessionStorage.setItem('stock-merchant-id', '')
            setCommonStore({
              type: 'currentMerchant',
              value: {}
            })
            setMerchantItem({})
          }
        }
      }
      setCommonStore({
        type: 'isGetIp',
        value: true
      })
    }catch(err) {
      sessionStorage.setItem('stock-merchant-id', '')
      setCommonStore({
        type: 'currentMerchant',
        value: {}
      })
      setMerchantItem({})
      setCommonStore({
        type: 'isGetIp',
        value: true
      })
    }
  }

  const isModernPhone = async () => {
    // 新标准设备检测 API (Chrome 89+)
    let _navigator: any = navigator
    if (_navigator.userAgentData) {
      const { mobile, platform } = await _navigator.userAgentData.getHighEntropyValues(
        ['mobile', 'platform']
      );
      // Android/iOS 平台 + 移动标志
      if (mobile && ['Android', 'iOS'].includes(platform)) {
        const deviceMemory = _navigator.deviceMemory || 0;
        return deviceMemory <= 8; // 排除高性能平板
      }
    }
    
    // 降级处理：屏幕尺寸 + 用户代理验证
    const maxDimension = Math.max(window.screen.width, window.screen.height);
    return maxDimension < 1000 && /Mobile/i.test(_navigator.userAgent);
  }
  
  const getNavgation = () => {
    accountApi.getNavgationNew({ domain: host || domain }).then((res: any) => {
      if(res.code === 1) {
        let navData = res.data
        let _allNav: any[] = []
        let cjhIndex = navData.findIndex((ele: any) => ele.path === '/cjh')
        let cjhItem = cjhIndex > -1 ? navData[cjhIndex] : {}
        let oeIndex = navData.findIndex((ele: any) => ele.path === '/oe')
        let oeItem = oeIndex > -1 ? navData[oeIndex] : {}
        navData.forEach((ele: any) => {
          if((ele.path === '/vin' || ele.path === '/cjh' || ele.path === '/carsearch') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/cjh')
            if(index === -1) {
              _allNav.push({
                path: '/cjh',
                is_add: 0,
                is_check: 1,
                name: cjhItem.name ? cjhItem.name : intl.formatMessage({id: '车架号查询'}),
                icon: ''
              })
            }
          }else if((ele.path === '/code' || ele.path === '/oe') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/oe')
            if(index === -1) {
              _allNav.push({
                path: '/oe',
                is_add: 0,
                is_check: 1,
                name: oeItem.name ? oeItem.name : intl.formatMessage({id: '零件号查询'}),
                icon: 'icon-lingjianchaxun'
              })
            }
          }else if(ele.is_add && ele.is_check) {
            ele.path = `/morepage/${ele.code}`
            _allNav.push(ele)
          }else if(ele.is_check) {
            if(ele.path === '/epc') {
              ele.icon = 'icon-EPCchaxun'
            }else if(ele.path === '/enquery') {
              ele.icon = 'icon-fabuxunjia'
            }
            _allNav.push(ele)
          }
        })
        let _standardNav = _allNav.filter((item: any, index: number) => index === 0 || (!item.is_add && item.is_check && item.path !== '/engine'))
        let _moreNav = _allNav.filter((item: any, index: number) => {
          if(item.is_add && item.is_check && index !== 0) {
            item.path = `/morepage/${item.code}`
            return true
          }
        })
        let filterStdNav = _standardNav
        if(filterStdNav.length < 4) {
          let lastIndexLen = 4 - filterStdNav.length
          let otherStandardNav = _moreNav.slice(0, lastIndexLen)
          _standardNav = [..._standardNav, ...otherStandardNav]
          _moreNav = _moreNav.slice(lastIndexLen)
        }
        let _homeUrl = _allNav[0] && _allNav[0].path ? _allNav[0].path : ''
        // console.log("homeUrl:", _homeUrl)
        setCommonStore({
          type: 'homeUrl',
          value: _homeUrl
        })
        console.log("_standardNav:", _standardNav)
        console.log("_moreNav:", _moreNav)
        console.log("_allNav:", _allNav)
        // setStandardNav(_standardNav)
        setAllNav(_allNav)
        setStandardNav(_standardNav)
        setMoreNav(_moreNav)
      }
    })
  }

  const setLang = (lang: "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "vie" | "fra" | "kor") => {
    setSearchParams({})
    window.localStorage.setItem('lang', lang)
    window.location.href = "/home"
  }

  const langItems: any = [
    {
      key: 'zh',
      label: (
        <div className="flex-s-c" onClick={() => setLang('zh')}>
          中文
        </div>
      )
    },
    {
      key: 'en',
      label: (
        <div className="flex-s-c" onClick={() => setLang('en')}>
          English
        </div>
      )
    },
    {
      key: 'ru',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ru')}>
          Русский язык
        </div>
      )
    },
    {
      key: 'fra',
      label: (
        <div className="flex-s-c" onClick={() => setLang('fra')}>
          French
        </div>
      )
    },
    {
      key: 'cht',
      label: (
        <div className="flex-s-c" onClick={() => setLang('cht')}>
        中文-繁體
        </div>
      )
    },
    {
      key: 'tr',
      label: (
        <div className="flex-s-c" onClick={() => setLang('tr')}>
        Türkiye
        </div>
      )
    },
    {
      key: 'ara',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ara')}>
          بالعربية
        </div>
      )
    },
    {
      key: 'pt',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pt')}>
          Português
        </div>
      )
    },
    {
      key: 'vie',
      label: (
        <div className="flex-s-c" onClick={() => setLang('vie')}>
          Tiếng Việt
        </div>
      )
    },
    {
      key: 'kor',
      label: (
        <div className="flex-s-c" onClick={() => setLang('kor')}>
          한국어
        </div>
      )
    },
    /* {
      key: 'may',
      label: (
        <div className="flex-s-c" onClick={() => setLang('may')}>
          Bahasa Melayu
        </div>
      )
    },
    {
      key: 'th',
      label: (
        <div className="flex-s-c" onClick={() => setLang('th')}>
          ภาษาไทย
        </div>
      )
    },
    {
      key: 'id',
      label: (
        <div className="flex-s-c" onClick={() => setLang('id')}>
          Bahasa Indonesia
        </div>
      )
    },
    {
      key: 'pl',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pl')}>
          Polski
        </div>
      )
    } */
  ].filter((item: any) => canLang && canLang.includes(item.key))

  const lang: any  = window.localStorage.getItem('lang')
  const merchantItems: any = useMemo(() => {
    let _items = merchantList.map((item: any) => {
      return {
        key: item.merchant_id,
        label: (
          <div 
            className="flex-s-c" 
            onClick={() => {
              window.sessionStorage.setItem('stock-merchant-id', item.merchant_id)
              const allParams = Object.fromEntries(searchParams.entries());
              setSearchParams({
                ...allParams,
                stock_merchant_id: item.merchant_id
              })
              setCommonStore({
                type: 'currentMerchant',
                value: item
              })
              setMerchantItem(item); 
              // window.location.href = "/home"
              window.location.reload ()
            }}
          >
            {item.erp_company}
          </div>
        )
      }
    })
    return _items
  }, [merchantList, pathname, search])

  const goToUrl = (item: any) => {
    let is_must = item.is_must
    let url = item.path
    
    if(url) {
      try {
        clear()
      }catch(err: any) {
        
      }
      setTimeout(() => {
        if(window.location.host.includes("partsbond") && url === '/epc') {
          if(window.localStorage.getItem("lang") === 'ru') {
            window.open('https://ru.partsbond.com',"__blank")
          }else {
            window.open('https://partsbond.com',"__blank")
          }
        }else {
          if(url === '/enquery' || url.includes('/epc')) {
            if(localStorage.getItem('token') && (!localStorage.getItem('tourist_user'))) {
              navigate(url)
            }else {
              message.warning(intl.formatMessage({ id: "请先登录" }))
              toGo('/login')
            }
          }else {
            navigate(url)
          }
        }
      },100)
      return false
    }
  }
  const toGo = (url: string) => {
    navigate(url)
  }

  const toCenterUrl = (url: string) => {
    navigate(url)
  }

  const logout = () => {
    accountApi.logout().then((res: any) => {
      if(res.code === 1) {
        localStorage.removeItem("token")
        localStorage.removeItem("ycid")
        localStorage.removeItem("openid")
        window.location.href = '/home'
      }
    })
  }

  const toHome = () => {
    navigate('/home')
  }

  const showMore = useMemo<any>(() => {
    if(isWomala || moreNav.length) {
      return [
        {
          name: intl.formatMessage({ id: '更多' }),
          key: 'more'
        }
      ]
    }else {
      return []
    }
  },[moreNav])

  const moreArr: any = isWomala ? [
    {
      name: intl.formatMessage({ id: '关于我们' }),
      path: '/aboutus',
      code: 'about_us',
      icon: 'icon-guanyuwomen'
    },
    {
      name: intl.formatMessage({ id: '联系我们' }),
      path: '/contactus',
      code: 'contract_us',
      icon: 'icon-lianxiwomen'
    },
    {
      name: intl.formatMessage({ id: '疑问解答' }),
      path: '/doubt',
      code: 'faq',
      icon: 'icon-yiwenjieda'
    },
    {
      name: intl.formatMessage({ id: '购买流程' }),
      path: '/buypath',
      code: 'purchase_process',
      icon: ''
    },
  ]: moreNav

  let _nowItem = moreArr.filter((item: any) => item.path === pathname)[0]

  const linkArr = [
    ...standardNav,
    ...showMore
  ]
  const _linkArr = longer ? [
    ...allNav
  ] : linkArr

  return (
    <>
      <div className={styles['mqp-header']}  >
        <div className={styles['mqp-header-t'] + ' plr30 flex-b-c'} style={{ background: '#F2F2F2' }}>
          <div className={styles['mqp-header-l'] + ' flex-s-c'}>
            {
              _linkArr.map((item: any, index: number) => {
                if(item.is_add || item.path === '/cjh' || item.path === '/oe') return null
                return (
                  <div onClick={() => {
                    goToUrl(item)
                  }} className={'mr30 pointer ' + `${pathname.indexOf(item.path) !== -1 ? 'p-color b' : ''}`}>{item.name}</div>
                )
              })
            }
          </div>
          <div className={styles['mqp-header-r'] + ' flex-s-c'}>
            {/* {
              isMobile ? <div className="flex-s-c mr30 pointer" onClick={toMobilePage}>{intl.formatMessage({id: '手机版'})}</div> : null
            } */}
            {
              commonStore.query_mode ? <div className='flex-s-c mr30'>
                <span>{intl.formatMessage({id: '发货仓'})}：</span>
                <Dropdown menu={{items: merchantItems}}>
                  <div className='flex-s-c'>
                    <span>{merchantItem.erp_company}</span>
                    <i className="iconfont icon-down ml5" />
                  </div>
                </Dropdown>
              </div> : null
            }
            {
              token && (!localStorage.getItem('tourist_user')) ? (
                <div className={'pointer'} onClick={() => toGo('/cart')}>{intl.formatMessage({ id: '购物车' })}({commonStore.cartNum})</div>
              ): null
            }
            <Dropdown menu={{ items: langItems }}>
              <div className={'pointer ml30'}>
                { lang === 'zh' ? '中文' 
                    : lang === 'en' ? 'English' 
                    : lang === 'ru' ? 'Русский язык' 
                    : lang === 'cht' ? '中文-繁體' 
                    : lang === 'tr' ? 'Türkiye' 
                    : lang === 'ara' ? 'بالعربية' 
                    : lang === 'pt' ? 'Português'
                    : lang === 'vie' ? 'Tiếng Việt' 
                    : lang === 'fra' ? 'French'
                    : lang === 'kor' ? '한국어' : '中文' }
              </div>
            </Dropdown>
            {
              token && (!localStorage.getItem('tourist_user')) ? <div className="flex-s-c ml30 pointer">
                <i className="iconfont icon-a-wo1 mr5"/>
                <Dropdown menu={{ items: centerItems.filter((it: any) => !isCst || !it.cstnot) }}>
                  <div className="flex-s-c">
                    {userInfo.wechat_nick || userInfo.phone}
                    <i className="iconfont icon-down ml5" />
                  </div>
                </Dropdown>
              </div> : <div className="flex-s-c ml30 pointer" onClick={() => toCenterUrl('/login')}>
                {intl.formatMessage({ id: '登录/注册' })}
              </div>
            }
          </div>
        </div>
        {
          !pathname.includes('/epc') && !pathname.includes('/productCatalog') ? (
            <div className={styles['mqp-header-b'] + ' flex-c-c'}>
              {
                token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <div className={styles['header-logo'] + ' pointer'}>
                  <LogoImg style={{maxWidth: config.logo_width, maxHeight: config.logo_height}} src={config.logo || ""}/>
                </div> : <div className={styles['header-logo'] + ' pointer'} onClick={toHome}>
                  <img src={config.logo || ""} alt="" />
                </div>
              }
              <ConfigProvider
                theme={{
                  token: {
                    /* 这里是你的全局 token */
                    colorBorder: colorPrimary,
                  },
                }}
              >
                <VinInput
                  placeholder={commonStore.headerInfo && commonStore.headerInfo.model_checked ? intl.formatMessage({id: '请输入OE/车架号/零件名称搜索'}) : intl.formatMessage({id: '搜索'})}
                  size="large"
                  width={750}
                  wrapStyle={{marginRight: 10, marginLeft: 10}}
                  style={{background: 'rgba(255, 255, 255, 0.8)', color: colorPrimary, borderColor: colorPrimary, borderRadius: 6}}
                  classNames={{
                    input: hasFreeVin ? styles['wkt-page-input'] : styles['wkt-page-input-2']
                  }}
                  value={vinInputKey}
                  cameraButtonStyle={{ color: colorPrimary, right: lang === 'ara' ? 'unset' : '80px', left: lang === 'ara' ? '80px' : 'unset' }}
                  enterButton={<Button type="primary" icon={<SearchOutlined/>} style={{width: 70,  borderColor: 'rgba(255, 255, 255, 0.8)'}}></Button>}
                  hasFreeVin={true}
                  canSearchOe={true}
                  freeVinButtonStyle={{right: lang === 'ara' ? 'unset' : '107px', left: lang === 'ara' ? '107px' : 'unset'}}
                  ismqp={true}
                />
              </ConfigProvider>
              {
                token ? <ExportinOe/> : null
              }
            </div>
          ): null
        }
      </div>
    </>
  )
}
export default HeaderFive